import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL } from "../utility/URL";


  const serchMember = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "member/search", data, headerConfig);
    return response.data;
  };

  const allMember = async () => {
    const response = await axios
        .post(BASE_API_URL + "member/list", {} , headerConfig);
    return response;
  };

  const memberListForTapRegistration = async () => {
    const response = await axios
        .post(BASE_API_URL + "member/member-list-tap-reg", {} , headerConfig);
    return response;
  };

  const allMemberListPersonalInfo = async () => {
    const response = await axios
        .post(BASE_API_URL + "member/all-personalinfo-list", {} , headerConfig);
    return response;
  };

  const allMemberTapList = async () => {
    const response = await axios
        .post(BASE_API_URL + "programme/tap-memberList-active-today", {} , headerConfig);
    return response;
  };

  const tapMemberListAllWithActiveInactive = async () => {
    const response = await axios
        .post(BASE_API_URL + "programme/tap-memberList-all", {} , headerConfig);
    return response;
  };

  const tapCoMemberList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/tap-co-memberList", data , headerConfig);
    return response;
  };

  const memberListByProgramme = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/member-list-programme", data , headerConfig);
    return response;
  };


  const memberListOnceTap = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/oncetap-memberlist", data , headerConfig);
    return response;
  };

  const programWiseMembersOutStanding = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/get-member-outstanding", data , headerConfig);
    return response;
  };

  const deleteMember = async (data) => {

    // console.log('headerConfig',headerConfig);
   

    const response = await axios
        .post(BASE_API_URL + "member/delete-member", data , headerConfig);
    return response;



  };

  const receiptHistory = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "member/receipt-history", data , headerConfig);
    return response;



  };

  const memberListByProgramGroup = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/member-data-programme", data , headerConfig);
    return response;
  };


  //  Inactive DORMENT Member //
  const inActiveDormantMembers = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/inactive-member", data, headerConfig);
        return response;
        console.log("responseTransfer", response)
};

const allMemberDueList = async (data) => {
  const response = await axios
      .post(BASE_API_URL + "member/member-due-monthly-fees", data , headerConfig);
  return response;
};

const allMemberPayNowDueList = async (data) => {
  const response = await axios
      .post(BASE_API_URL + "member/member-due-amt-dtl", data , headerConfig);
  return response;
};

const allMemberDuePayment = async (data) => {
  const response = await axios
      .post(BASE_API_URL + "monthly-due/monthly-due-insert", data , headerConfig);
  return response;
};

const getActiveMemberByProgrammeId = async (data) => {
  const response = await axios
      .post(BASE_API_URL + "account/get-active-member-by-prg", data , headerConfig);
  return response;
};

const getAllDiscontinuedMembers = async () => {
  const response = await axios
      .post(BASE_API_URL + "member/get-all-discontined-member", {} , headerConfig);
  return response;
};

const MemberContinue = async (data) => {
  const response = await axios
      .post(BASE_API_URL + "member/member-continue", data , headerConfig);
  return response;
};

const memberService = {
    serchMember,
    allMember,
    memberListByProgramme,
    allMemberTapList,
    tapMemberListAllWithActiveInactive,
    memberListOnceTap,
    allMemberListPersonalInfo,
    memberListForTapRegistration,
    tapCoMemberList,
    programWiseMembersOutStanding,
    deleteMember,
    receiptHistory,
    memberListByProgramGroup,
    inActiveDormantMembers,
    allMemberDueList,
    allMemberPayNowDueList,
    allMemberDuePayment,
    getActiveMemberByProgrammeId,
    getAllDiscontinuedMembers,
    MemberContinue
};

export default memberService;